var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHamburgerMenuIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 310,
    height: 259.344,
    viewBox: "0 0 310 259.344",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.016 -803.031)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 20.336
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.668 1032.694h250.646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.668 932.694h250.646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.668 832.694h250.646"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHamburgerMenuIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hamburger-menu-icon.e13550211ca1e9e52ee7d7847ea3fa1a.svg";